export const API_PARTNERS_TRANSLATIONS_FIELDS = [
    'partner.translations.id',
    'partner.translations.languages_code',
    'partner.translations.name'
];
export const API_PROJECTS_PARTNERS_ID_TRANSLATIONS_FIELDS = [
    'partners.partner_id.translations.id',
    'partners.partner_id.translations.languages_code.lang',
    'partners.partner_id.translations.languages_code.url',
    'partners.partner_id.translations.name'
];
